import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  title = 'app';
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/app.component.ts